<template>
  <transition name="modal" appear>
    <div class="app-modal" @click="$emit('close')">
      <div @click.stop class="modal-area" :style="{ width: width }">
        <div v-if="heading" class="modal-area__header">
          {{ heading }}
        </div>
        <div class="pt-5">
          <slot name="content" />
        </div>
      </div>
    </div>
  </transition>
</template>
<script>

export default {
  name: 'AppModal',
  props: {
    heading: {
      type: String,
      default: null
    },
    width: {
      type: String,
      default: '680px'
    }
  }
}
</script>
<style lang="scss" scoped>
  .app-modal {
    @apply fixed px-5 h-full inset-0 bg-dark z-50 bg-opacity-50 text-base flex transition-all duration-150 ease-linear;
    .modal-area {
      @apply z-10 bg-white m-auto align-middle rounded-lg w-full rounded-lg p-5 overflow-auto;
      max-height: calc(100vh - 6rem);
      max-width: 100%;
      @screen md {
        @apply py-6 px-16;
        max-height: calc(100vh - 2rem);
      }
      &__header {
        @apply text-lg text-blue font-bold flex justify-between py-2 border-b border-dark-b;
        @screen md { @apply text-2xl; }
      }
    }
    /* width */
    ::-webkit-scrollbar {
      width: 4px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: rgba(35, 31, 32, 0.15);
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: #a0aec0;
    }
  }
</style>
